var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as moment from 'moment';
import { InfoPopupComponent } from '../info-popup/info-popup.component';
import { UserService } from '../../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AchievementService } from 'app/shared/services/achievement.service';
import { HelpDialogComponent } from '../achievement/components/help-dialog/help-dialog.component';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
var AchievementLevel;
(function (AchievementLevel) {
    AchievementLevel["UNLOCKED"] = "unlocked";
    AchievementLevel["GREEN"] = "green";
    AchievementLevel["BRONZE"] = "bronze";
    AchievementLevel["SILBER"] = "silber";
    AchievementLevel["GOLD"] = "gold";
})(AchievementLevel || (AchievementLevel = {}));
var AchievementComponent = (function () {
    function AchievementComponent(userService, achievementService, dialog, translateService) {
        this.userService = userService;
        this.achievementService = achievementService;
        this.dialog = dialog;
        this.translateService = translateService;
        this.aliasForm = new FormGroup({
            alias: new FormControl('', [Validators.maxLength(30)]),
        });
        this.date = moment();
        this.loadAllAchievements();
    }
    /**
     * Translates achievement name using the translation service
     * @param achievementName The original achievement name
     * @returns The translated achievement name
     */
    AchievementComponent.prototype.translateAchievementName = function (achievementName) {
        // If achievement name is missing or empty, return empty string
        if (!achievementName) {
            return '';
        }
        var translationKey = "ACHIEVEMENTS.achievementNames." + achievementName;
        var translation = this.translateService.instant(translationKey);
        // Return original name if translation is not found (returns the key)
        return translation === translationKey ? achievementName : translation;
    };
    /**
     * Translates achievement description using the translation service
     * @param achievementName The original achievement name
     * @returns The translated achievement description
     */
    AchievementComponent.prototype.translateAchievementDescription = function (achievementName) {
        // If achievement name is missing or empty, return empty string
        if (!achievementName) {
            return '';
        }
        var translationKey = "ACHIEVEMENTS.achievementDescriptions." + achievementName;
        var translation = this.translateService.instant(translationKey);
        // If no translation is found, fall back to original description
        if (translation === translationKey) {
            // Find the achievement in our data
            var achievement = this.achievementData && this.achievementData.find(function (a) { return a.name === achievementName; });
            return (achievement && achievement.description) ? achievement.description : '';
        }
        return translation;
    };
    AchievementComponent.prototype.ngAfterViewInit = function () {
        this.userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
        });
    };
    AchievementComponent.prototype.loadAllAchievements = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.achievementService.getAllAchievementsForUser()];
                    case 1:
                        data = _a.sent();
                        this.achievementData = data;
                        this.achievementChunks = this.achievementService.chunkArray(this.achievementData, 1);
                        return [2 /*return*/];
                }
            });
        });
    };
    AchievementComponent.prototype.loadUnlockedAchievements = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, unlockedAchievements;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.achievementService.getAllAchievementsForUser()];
                    case 1:
                        data = _a.sent();
                        unlockedAchievements = data.filter(function (achievement) {
                            return achievement.hasLevels ? achievement.progress >= achievement.levels.green : achievement.progress === 1;
                        });
                        this.achievementData = unlockedAchievements;
                        this.achievementChunks = this.achievementService.chunkArray(this.achievementData, 1);
                        return [2 /*return*/];
                }
            });
        });
    };
    AchievementComponent.prototype.loadLockedAchivements = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, lockedAchievements;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.achievementService.getAllAchievementsForUser()];
                    case 1:
                        data = _a.sent();
                        lockedAchievements = data.filter(function (achievement) {
                            return achievement.hasLevels ? achievement.progress < achievement.levels.green : achievement.progress === 0;
                        });
                        this.achievementData = lockedAchievements;
                        this.achievementChunks = this.achievementService.chunkArray(this.achievementData, 1);
                        return [2 /*return*/];
                }
            });
        });
    };
    AchievementComponent.prototype.getNextAchivementLevel = function (achievement) {
        var currentLevel = this.getCurrentAchievementLevel(achievement);
        var levelsArr = [
            AchievementLevel.UNLOCKED,
            AchievementLevel.GREEN,
            AchievementLevel.BRONZE,
            AchievementLevel.SILBER,
            AchievementLevel.GOLD,
        ];
        var currentIndex = levelsArr.indexOf(currentLevel);
        if (currentIndex === levelsArr.length - 1) {
            return AchievementLevel.GOLD;
        }
        else {
            return levelsArr[currentIndex + 1];
        }
    };
    AchievementComponent.prototype.getCurrentAchievementLevel = function (achievement) {
        var progress = achievement.progress;
        var levels = achievement.levels;
        var levelsArr = [AchievementLevel.GREEN, AchievementLevel.BRONZE, AchievementLevel.SILBER, AchievementLevel.GOLD];
        if (levels) {
            var progressToNextLevel = progress;
            var currentLevel = AchievementLevel.UNLOCKED;
            for (var _i = 0, levelsArr_1 = levelsArr; _i < levelsArr_1.length; _i++) {
                var levelName = levelsArr_1[_i];
                var level = levels[levelName];
                if (progressToNextLevel >= level) {
                    currentLevel = levelName;
                    progressToNextLevel -= level;
                }
                else {
                    break; // Stop checking once the current level is found
                }
            }
            return currentLevel;
        }
        else if (achievement.finishedAt || (!achievement.hasLevels && achievement.progress === 1)) {
            return AchievementLevel.GOLD;
        }
        else {
            return AchievementLevel.UNLOCKED;
        }
    };
    AchievementComponent.prototype.getProgressString = function (achievement) {
        if (achievement.hasLevels) {
            var currentLevel = this.getCurrentAchievementLevel(achievement);
            var currentProgress = this.getCurrentAchievementProgress(achievement);
            switch (currentLevel) {
                case AchievementLevel.UNLOCKED:
                    return currentProgress + "/" + achievement.levels.green;
                case AchievementLevel.GREEN:
                    return currentProgress + "/" + achievement.levels.bronze;
                case AchievementLevel.BRONZE:
                    return currentProgress + "/" + achievement.levels.silber;
                case AchievementLevel.SILBER:
                    return currentProgress + "/" + achievement.levels.gold;
                case AchievementLevel.GOLD:
                    return '';
            }
        }
        else {
            return '';
        }
    };
    AchievementComponent.prototype.getProgressColor = function (achievement) {
        if (achievement.hasLevels) {
            var currentLevel = this.getCurrentAchievementLevel(achievement);
            switch (currentLevel) {
                case AchievementLevel.UNLOCKED:
                    return '#929292';
                case AchievementLevel.GREEN:
                    return '#1F8D16';
                case AchievementLevel.BRONZE:
                    return '#8F551B';
                case AchievementLevel.SILBER:
                    return '#646464';
            }
        }
    };
    AchievementComponent.prototype.getCurrentAchievementProgress = function (achievement) {
        var currentLevel = this.getCurrentAchievementLevel(achievement);
        var levels = achievement.levels;
        var currentProgress = achievement.progress;
        switch (currentLevel) {
            case AchievementLevel.UNLOCKED:
                return currentProgress;
            case AchievementLevel.GREEN:
                return currentProgress - levels[AchievementLevel.GREEN];
            case AchievementLevel.BRONZE:
                return currentProgress - levels[AchievementLevel.GREEN] - levels[AchievementLevel.BRONZE];
            case AchievementLevel.SILBER:
                return (currentProgress -
                    levels[AchievementLevel.GREEN] -
                    levels[AchievementLevel.BRONZE] -
                    levels[AchievementLevel.SILBER]);
            case AchievementLevel.GOLD:
                return (currentProgress -
                    levels[AchievementLevel.GREEN] -
                    levels[AchievementLevel.BRONZE] -
                    levels[AchievementLevel.SILBER] -
                    levels[AchievementLevel.GOLD]);
        }
    };
    AchievementComponent.prototype.getProgressPercentage = function (achievement) {
        if (!achievement.hasLevels) {
            return 0;
        }
        var progress = this.getCurrentAchievementProgress(achievement);
        var nextLevel = this.getNextAchivementLevel(achievement);
        var limit = achievement.levels[nextLevel];
        var progressPercentage = Math.floor((progress * 100) / limit);
        return progressPercentage;
    };
    AchievementComponent.prototype.showHelpPage = function () {
        var dialogRef = this.dialog.open(HelpDialogComponent, {
            maxWidth: '800px',
            maxHeight: '600px',
            width: '80%',
            height: '100%',
        });
    };
    AchievementComponent.prototype.toggleAll = function () {
        // fetch all achivements
        this.loadAllAchievements();
    };
    AchievementComponent.prototype.toggleLocked = function () {
        // fetch open achivements
        this.loadLockedAchivements();
    };
    AchievementComponent.prototype.toggleUnlocked = function () {
        // fetch unlocked achivements
        this.loadUnlockedAchievements();
    };
    return AchievementComponent;
}());
export { AchievementComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/achievement/achievement.component.ts.pre-build-optimizer.js